export default __webpack_public_path__ + "static/media/filledTick.0a260ddb.svg";